import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { normalizeFaNumbers } from "../../../utils/methods";
import DBButton from "../../../component/global/DBButton";
import DBCheckbox from "../../../component/global/DBCheckbox";
import { post } from "../../../controlers/global/ConfigRequest";
import { REGISTER_USER } from "../../universalData";
import { LOGIN_ADDRESS } from "../../../helperData/ApiAddress";
import { GlobalStateContext } from "../../../layouts/GlobalStates";

const OTP_LENGTH = 5;
const emptyOtp = "*".repeat(OTP_LENGTH);

function FoodOrderLoginModal({ show, itemName }) {
    const { auth, setAuth, setRefreshNewCount } =
        React.useContext(GlobalStateContext);
    const { t } = useTranslation();
    const [code, setCode] = useState(emptyOtp);
    const [phone, setPhone] = useState("");
    const [phoneErr, setPhoneErr] = useState("");
    const [privacy, setPrivacy] = useState(false);
    const [error, setError] = useState("");
    const [sendOtp, setSendOtp] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!show) {
            setPhoneErr("");
            setPhone("");
            setError("");
            setSendOtp(false);
            setPrivacy(false);
            setIsLoading(false);
            setCode(emptyOtp);
        }
    }, [show]);

    const codeTabHandle = (e) => {
        if (e.which === 8 && e.target.value === "") {
            e.target.previousElementSibling?.focus();
            e.target.previousElementSibling?.select();
        } else if (e.target.value.length === 1) {
            e.target.nextElementSibling?.focus();
            e.target.nextElementSibling?.select();
        }
    };
    const codeValueHandle = (e, index) => {
        let temp = [...code];

        if (e.target.value.length === 1) {
            temp[index] = normalizeFaNumbers(e.target.value);
        }
        if (e.target.value.length === 0) {
            temp[index] = "*";
        }
        setCode(temp.join(""));
    };

    const phoneHandle = (e) => {
        const patt = new RegExp(/^\+?([0-9]*)$/);
        if (patt.test(e.target.value) || e.target.value === "") {
            setPhoneErr("");
            setPhone(e.target.value);
        }
    };

    const sendOTPHandle = () => {
        if (phoneErr) return true;
        if (!privacy) {
            setError(t("feedback.privacy.error"));
            return true;
        }
        let phoneStr;
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                return false;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                return false;
            }
            phoneStr = "+98" + phone.substring(1);
        } else {
            setPhoneErr(t("Src.Component.Global.AuthModal.Login.setPhoneErr"));
            return false;
        }
        setIsLoading(true);
        post(REGISTER_USER, { phone_number: phoneStr })
            .then((res) => {
                console.log("FoodOrderLoginModal res", res);
                setError("");
                setSendOtp(true);
            })
            .catch((err) => {
                console.log("FoodOrderLoginModal err", err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const otpLoginHandle = () => {
        let hasErr = false;
        let phoneStr;
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                hasErr = true;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                hasErr = true;
            }
            phoneStr = "+98" + phone.substr(1);
        } else {
            setPhoneErr(t("Src.Component.Global.AuthModal.Login.setPhoneErr"));
            hasErr = true;
        }

        if (hasErr) return false;
        setIsLoading(true);
        setError("");
        post(LOGIN_ADDRESS, {
            username: phoneStr,
            password: code.replace(/\*/g, ""),
            grant_type: "password",
        })
            .then((r) => {
                window.sessionStorage.auth = r.access_token;
                window.sessionStorage.username = r.user.username;
                window.sessionStorage.id = r.user.id;
                window.sessionStorage.usertype = r.user.user_level;
                window.sessionStorage.usercompany = r.user.company;
                window.sessionStorage.first_name = r.user.first_name;
                window.sessionStorage.last_name = r.user.last_name;
                window.sessionStorage.package = JSON.stringify(
                    r.user.package || {}
                );
                window.sessionStorage.company_admin = r.user.company_admin;
                window.sessionStorage.email = r.user.email;

                setRefreshNewCount((prevState) => !prevState);

                setAuth({
                    ...auth,
                    id: r.user.id,
                    access_token: r.access_token,
                    username: r.user.username,
                    usertype: r.user.user_level,
                    usercompany: r.user.company,
                    first_name: r.user.first_name,
                    last_name: r.user.last_name,
                    package: r.user.package || {},
                    company_admin: r.user.company_admin,
                    email: r.user.email,
                });
            })
            .catch(() => {
                setError(
                    t("Src.Component.Global.AuthModal.Login.setResultCodeErr")
                );
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <div className="food-order-login-hint">
                {itemName
                    ? t("feedback.login.club.hint", { name: itemName })
                    : t("feedback.login.club.hintFallback")}
            </div>
            <div className="food-order-form">
                <input
                    value={phone}
                    className="food-order-login-phoneNumber"
                    placeholder={t("feedback.login.phoneNumber.placeholder")}
                    inputMode="decimal"
                    onChange={phoneHandle}
                    readOnly={sendOtp}
                />
                {phoneErr ? (
                    <div className="food-order-error">{phoneErr}</div>
                ) : null}
            </div>
            {sendOtp ? (
                <div className="food-order-login-otp" dir="ltr">
                    {Array.from({ length: OTP_LENGTH }, (_, index) => (
                        <input
                            key={index}
                            type="text"
                            inputMode="numeric"
                            autoComplete={index === 0 ? "one-time-code" : "off"}
                            maxLength={1}
                            onKeyUp={codeTabHandle}
                            value={code[index] === "*" ? "" : code[index] || ""}
                            onChange={(e) => codeValueHandle(e, index)}
                            placeholder={String(index + 1)}
                            aria-label={`${t("enter.code")} ${index + 1}`}
                        />
                    ))}
                </div>
            ) : null}
            {!sendOtp ? (
                <>
                    <div className="food-order-privacy">
                        <DBCheckbox
                            checked={privacy}
                            onClick={() => {
                                setError("");
                                setPrivacy((prevState) => !prevState);
                            }}
                        />
                        <div className="food-order-privacy-text">
                            {t("form.rules.checkbox").split("*")[0]}
                            <span>
                                {t("form.rules.checkbox").split("*")[1]}
                            </span>
                            {t("form.rules.checkbox").split("*")[2]}
                        </div>
                    </div>
                </>
            ) : null}
            {error ? <div className="food-order-error">{error}</div> : null}
            {sendOtp ? (
                <DBButton
                    className="food-orders-send-order"
                    caption={t("feedback.send")}
                    onClick={otpLoginHandle}
                    loading={isLoading}
                />
            ) : (
                <DBButton
                    className="food-order-btn-next"
                    caption={t("feedback.login.Otp.Btn.Label")}
                    onClick={sendOTPHandle}
                    loading={isLoading}
                />
            )}
        </>
    );
}

export default FoodOrderLoginModal;
